export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-bitcoin-circle-341f77f37e0fb437eb106e686fa6a125.svg";